import React, { useCallback } from 'react';
import { toast } from "sonner";

export const useErrorHandler = () => {
  const handleError = useCallback((error, context = 'Application') => {
    console.error(`${context} error:`, error);
    
    // Determine user-friendly error message
    let message = 'An unexpected error occurred';
    
    if (error?.message) {
      if (error.message.includes('Network')) {
        message = 'Network connection issue. Please check your internet connection.';
      } else if (error.message.includes('timeout')) {
        message = 'Request timed out. Please try again.';
      } else if (error.status === 429) {
        message = 'Too many requests. Please wait a moment and try again.';
      } else {
        message = error.message;
      }
    }

    toast.error(message, {
      duration: 5000,
    });
  }, []);

  const withErrorHandler = useCallback((asyncFn, context) => {
    return async (...args) => {
      try {
        return await asyncFn(...args);
      } catch (error) {
        handleError(error, context);
        throw error;
      }
    };
  }, [handleError]);

  return { handleError, withErrorHandler };
};